import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent {

  baseUrl = environment.apiBaseUrl;
  
   editingImage: any = null;
  selectedFile: File | null = null;
  images: any[] = [];

   titleInput = '';

   // showGallery = false; // فقط اسلایدر نمایش داده می‌شود
  showGallery = true;

  constructor(private http: HttpClient) {}


   ngOnInit(): void {
    // this.startAutoSlide();

    this.loadImages();
  }

  onFileSelected(event: any): void {
    this.selectedFile = event.target.files[0];
  }
  editImage(image: any) {
    this.editingImage = { ...image }; // کپی برای جلوگیری از تغییر مستقیم
  }

  cancelEdit() {
    this.editingImage = null;
    this.selectedFile = null;
  }

  loadImages(): void {
  this.http.get<any[]>(`${this.baseUrl}/gallery`).subscribe((res) => {
    this.images = res;
    // console.log(res)
  });
  }

  updateImage() {
    const formData = new FormData();
    formData.append('id', this.editingImage.id); // ← اضافه شد چون الان از /gallery/update استفاده می‌کنی

    formData.append('title', this.editingImage.title);
    if (this.selectedFile) {
      formData.append('imageFile', this.selectedFile);
    }

  // this.http.put(`${this.baseUrl}/gallery/${this.editingImage.id}`, formData)
  this.http.post(`${this.baseUrl}/gallery/update`, formData).subscribe({
    
      next: (updated: any) => {
        // بروزرسانی در لیست
        const index = this.images.findIndex(i => i.id === updated.id);
        if (index !== -1) this.images[index] = updated;
        this.cancelEdit();
      },
      error: err => {
        console.error("خطا در ویرایش:", err);
        alert("ویرایش تصویر با خطا مواجه شد.");
      }
    });
}
  uploadImage(): void {
    if (!this.selectedFile || !this.titleInput.trim()) return;

    const formData = new FormData();
    formData.append('title', this.titleInput);
    formData.append('imageFile', this.selectedFile);

    this.http.post(`${this.baseUrl}/gallery/upload`, formData)
      .subscribe(() => {
        this.loadImages();
        this.titleInput = '';
        this.selectedFile = null;
      });
  }

 deleteImage(id: number) {
  if (!confirm("آیا از حذف مطمئن هستید؟")) return;
   
    const formData = new FormData();
    formData.append('id', id.toString());

  // this.http.delete(`${this.baseUrl}/gallery/${id}`, { responseType: 'text' }).subscribe({
   this.http.post(`${this.baseUrl}/gallery/delete`, formData).subscribe({
  next: () => {
    this.images = this.images.filter(img => img.id !== id);
    alert("تصویر با موفقیت حذف شد.");
  },
  error: err => {
    console.error("خطا در حذف:", err);
    alert("حذف تصویر با خطا مواجه شد.");
  }
});
 
}
}
